// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"
import "./src/styles/index.css"
import "./src/styles/layout.css"
import "./src/styles/blog-post.css"